export const Constants = {
    assetPageSize: 20,
};
